module.exports = __webpack_public_path__ + "img/city_books.9d3d114a.png";